/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".not-found[_ngcontent-%COMP%]{height:400px;width:80%;margin:10% auto}.not-found[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:36px;font-weight:700;color:#5f6062}.not-found[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-size:24px;font-weight:lighter;color:#2e2f2e}.not-found[_ngcontent-%COMP%]   .btn-back[_ngcontent-%COMP%]{font-size:24px}"];
export { styles as styles };
